import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#D7207C",
      d: "M12 16.675 7.175 11.85l1.075-1.075 3 3V4.5h1.5v9.275l3-3 1.075 1.075zM5.5 20.5q-.6 0-1.05-.45T4 19v-3.575h1.5V19h13v-3.575H20V19q0 .6-.45 1.05t-1.05.45z"
    }, null, -1)
  ]))]))
}
export default { render: render }